const videoAnalytics = function ({ player, info, videoSectionType, courseTitle = undefined }) {
  const sessionId = `session_${info.userId}_${Date.now()}`;

  let heartbeatTimeout;
  let heartbeatIntervalBreakpointMeasurement;
  const heartbeatInterval = 10000;

  let preventVideoPauseAnalytics = false;

  let startPointPlayTime;
  let lustUpdatedPlayLineTime = null;

  let isVideoSeeking = false;
  let previousVideoSeekPlayTime = null;

  let previousPlayRate = player.playbackRate;
  let previousVolume = player.volume;

  let videoStopped = true;

  const handlePlay = () => {
    if (isVideoSeeking) return;

    videoStopped = false;
    
    startPointPlayTime = player.currentTime;

    const playbackStartedEvent = videoAnalyticsEventConstructor(player, "Video Playback Started", videoSectionType, sessionId, info, courseTitle);
        
    console.log(playbackStartedEvent);
    window.analytics?.track(playbackStartedEvent);

    heartbeat(player, heartbeatInterval);
  };

  const handlePause = () => {
    if (videoStopped) return;

    if (preventVideoPauseAnalytics) {
      preventVideoPauseAnalytics = false;
      return;
    }

    clearTimeout(heartbeatTimeout);

    const additionalInfo = {
      ...info, 
      chunk_video_played_time: lustUpdatedPlayLineTime - startPointPlayTime, 
      chunk_real_watched_time: (lustUpdatedPlayLineTime - startPointPlayTime) / player.playbackRate
    };

    const playbackPausedEvent = videoAnalyticsEventConstructor(player, "Video Playback Paused", videoSectionType, sessionId, additionalInfo, courseTitle);

    startPointPlayTime = null;

    clearInterval(heartbeatIntervalBreakpointMeasurement);

    videoStopped = true;

    console.log(playbackPausedEvent);
    window.analytics?.track(playbackPausedEvent);
  };

  const handlePlayRateChange = () => {
    const playbackPlayRateChangeEvent = videoAnalyticsEventConstructor(player, "Video Playback Speed Changed", videoSectionType, sessionId, {...info, changed_from: previousPlayRate }, courseTitle);
    
    console.log(playbackPlayRateChangeEvent);
    window.analytics?.track(playbackPlayRateChangeEvent);

    if (!player.paused) {
      const additionalInfo = {
        ...info, 
        chunk_video_played_time: lustUpdatedPlayLineTime - startPointPlayTime, 
        chunk_real_watched_time: (lustUpdatedPlayLineTime - startPointPlayTime) / previousPlayRate,
        playback_rate: previousPlayRate
      };

      const playbackHeartbeatEvent = videoAnalyticsEventConstructor(player, "Video Playing", videoSectionType, sessionId, additionalInfo, courseTitle);

      console.log(playbackHeartbeatEvent);
      window.analytics?.track(playbackHeartbeatEvent);

      startPointPlayTime = player.currentTime;
      previousPlayRate = player.playbackRate;
      
      heartbeat(player, heartbeatInterval);
    }
  };

  const handleVolumeChange = () => {
    const playbackVolumeChangeEvent = videoAnalyticsEventConstructor(player, "Video Playback Volume Changed", videoSectionType, sessionId, {...info, changed_from: previousVolume }, courseTitle);

    previousVolume = player.volume;
    
    console.log(playbackVolumeChangeEvent);
    window.analytics?.track(playbackVolumeChangeEvent);
  };

  const handleTimeUpdate = () => {
    if (!player.paused) setTimeout(() => {lustUpdatedPlayLineTime = player.currentTime;}, 0)
    if (!player.paused && !isVideoSeeking) previousVideoSeekPlayTime = player.currentTime;
  };

  const handleSeeking = () => {
    !isVideoSeeking && !player.paused && handlePause();
    isVideoSeeking = true;
  };

  const handleSeeked = () => {
    const playbackVideoSeekEvent = videoAnalyticsEventConstructor(player, "Video Seek Completed", videoSectionType, sessionId, {...info, changed_from: previousVideoSeekPlayTime}, courseTitle);
    
    previousVideoSeekPlayTime = player.currentTime;
    isVideoSeeking = false;
    
    !player.paused && handlePlay();

    console.log(playbackVideoSeekEvent);
    window.analytics?.track(playbackVideoSeekEvent);
  };

  function heartbeat(player, heartbeatInterval) {
    clearTimeout(heartbeatTimeout);
    clearInterval(heartbeatIntervalBreakpointMeasurement);

    let breakpointCounter = 0;
    let clipDuration = player.duration;
    let playbackRate = player.playbackRate;

    heartbeatIntervalBreakpointMeasurement = setInterval(() => {
      if (!Number.isNaN(player.duration)) breakpointCounter += 1;
    }, 1000)

    heartbeatTimeout = setTimeout(() => {      
      const additionalInfo = Number.isNaN(player.duration)
        ? {
          ...info, 
          chunk_video_played_time: breakpointCounter < 0 ? 0 : breakpointCounter, 
          chunk_real_watched_time: breakpointCounter < 0 ? 0 : breakpointCounter / playbackRate,
          duration: clipDuration,
          playback_rate: playbackRate
        }
        : {
          ...info, 
          chunk_video_played_time: player.currentTime - startPointPlayTime, 
          chunk_real_watched_time: (player.currentTime - startPointPlayTime) / player.playbackRate
        }

      const playbackHeartbeatEvent = videoAnalyticsEventConstructor(
        player, 
        Number.isNaN(player.duration) ? "Video Playback Paused" : "Video Playing",
        videoSectionType,
        sessionId,
        additionalInfo,
        courseTitle
      );

      startPointPlayTime = player.currentTime;

      console.log(playbackHeartbeatEvent);
      window.analytics?.track(playbackHeartbeatEvent);

      if (!Number.isNaN(player.duration)) heartbeat(player, heartbeatInterval);
    }, heartbeatInterval);
  }

  player.addEventListener("play", handlePlay);
  player.addEventListener("pause", handlePause);
  player.addEventListener("ratechange", handlePlayRateChange);
  player.addEventListener("volumechange", handleVolumeChange);

  player.addEventListener("seeking", handleSeeking);
  player.addEventListener("seeked", debounce(handleSeeked, 500));

  player.addEventListener("timeupdate", handleTimeUpdate);

  // player.addEventListener("ended", handleFinalHeartBeat);
  // player.addEventListener("error", handleFinalHeartBeat);
  // player.addEventListener("stalled", handleFinalHeartBeat);

  window.onbeforeunload = function(e) {
    if (!player) {
      window.onbeforeunload = function(e) {};
    }

    if (!player.paused) {
      setTimeout(() => player.play(), 0);

      handlePause();
      preventVideoPauseAnalytics = true;
      player.pause();

      return 'Video is playing. Are you sure you want to exit?';
    }
  };

  if (!player.paused) handlePlay();
};

function videoAnalyticsEventConstructor(player, eventName, videoSectionType, sessionId, additionalInfo, courseTitle) {
  let playbackAnalyticsProperties;
  const path = window.location.pathname;

  switch(eventName) {
    case "Video Playback Started":
      playbackAnalyticsProperties =  {
        event: `${videoSectionType}_video:play`,
        properties: {
          session_id: sessionId,
          path,
          start_at: player.currentTime,
          duration: player.duration,
          sound: player.volume,
          playback_rate: player.playbackRate,
          ...additionalInfo,
        },
      };
      break;
    case "Video Playing":
      playbackAnalyticsProperties = {
        event: `${videoSectionType}_video:continuing`,
        properties: {
          session_id: sessionId,
          path,
          playing_at: player.currentTime,
          duration: player.duration,
          sound: player.volume,
          playback_rate: player.playbackRate,
          ...additionalInfo,
        },
      };
      break;
    case "Video Playback Paused":
      playbackAnalyticsProperties = {
        event: `${videoSectionType}_video:stop`,
        properties: {
          session_id: sessionId,
          path,
          stop_at: player.currentTime,
          duration: player.duration,
          sound: player.volume,
          playback_rate: player.playbackRate,
          ...additionalInfo,
        },
      };
      break;
    case "Video Seek Completed":
      playbackAnalyticsProperties = {
        event: `${videoSectionType}_video:time`,
        properties: {
          session_id: sessionId,
          path,
          duration: player.duration,
          sound: player.volume,
          playback_rate: player.playbackRate,
          changed_to: player.currentTime,
          ...additionalInfo,
        },
      };
      break;
    case "Video Playback Speed Changed":
      playbackAnalyticsProperties = {
        event: `${videoSectionType}_video:speed`,
        properties: {
          session_id: sessionId,
          path,
          duration: player.duration,
          sound: player.volume,
          speed_changed_at: player.currentTime,
          changed_to: player.playbackRate,
          ...additionalInfo,
        },
      };
      break;
    case "Video Playback Volume Changed":
      playbackAnalyticsProperties = {
        event: `${videoSectionType}_video:sound`,
        properties: {
          session_id: sessionId,
          path,
          duration: player.duration,
          playback_rate: player.playbackRate,
          volume_changed_at: player.currentTime,
          changed_to: player.volume,
          ...additionalInfo,
        },
      };
      break;
    default:
      break;
  }

  if (courseTitle) playbackAnalyticsProperties.properties.course_title = courseTitle;

  return playbackAnalyticsProperties;
}

const debounce = (callback, wait) => {
  let timeoutId = null;
  return (...args) => {
    window.clearTimeout(timeoutId);
    timeoutId = window.setTimeout(() => {
      callback.apply(null, args);
    }, wait);
  };
};

export default videoAnalytics;